var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5652 5.49622C20.2557 6.75528 21.1009 7.38481 21.5504 8.22966C22 9.07451 22 10.0334 22 11.9512V13.4425C22 17.4766 22 19.4936 20.5355 20.7468C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.7468C2 19.4936 2 17.4766 2 13.4425L2 11.9512C2 10.0334 2 9.07451 2.44955 8.22966C2.89911 7.38481 3.74432 6.75528 5.43476 5.49622C8.56413 3.16541 10.1288 2 12 2C13.8712 2 15.4359 3.16541 18.5652 5.49622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 16.25,
    width: 6.5,
    height: 6.5,
    rx: 3.25,
    transform: "rotate(-180 15.25 16.25)",
    stroke: "#252525",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome5);
export default __webpack_public_path__ + "static/media/home5.f6d52ddf5646a3e4a53ace6fc77dd9fc.svg";
export { ForwardRef as ReactComponent };